import { addItemToList, createList } from './bao-swym.js'

class WishlistModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.handleAddToWishlist = this.handleAddToWishlist.bind(this)
    this.handleCreateNewList = this.handleCreateNewList.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)

    this.listeners.add(document, 'keydown', this.handleKeyDown)

    this.els.close.elements.forEach(el => {
      this.listeners.add(el, 'click', this.handleClose)
    })

    this.listeners.add(
      this.els.addToWishlistButton.element,
      'click',
      this.handleAddToWishlist,
    )
    this.listeners.add(
      this.els.createNewListButton.element,
      'click',
      this.handleCreateNewList,
    )

    document.addEventListener('swym-item-added', data => {
      this.handleClose()
    })
  }

  get isOpen () {
    return this.getAttribute('aria-hidden') === 'false'
  }

  show () {
    this.activeTrigger = document.activeElement

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
    this.focusFirstElement()
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
    this.resetForm()
    this.returnFocus()
  }

  focusFirstElement () {
    setTimeout(() => {
      const focusTarget =
        this.querySelector('button[data-wishlist-modal-el="close"]') ||
        this.getFocusableElements()[0]
      if (focusTarget) focusTarget.focus()
    }, 500)
  }

  returnFocus () {
    if (this.activeTrigger) {
      this.activeTrigger.focus()
      this.activeTrigger = null
    }
  }

  handleKeyDown (event) {
    if (!this.isOpen) return

    if (event.key === 'Escape') {
      this.handleClose()
      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  trapFocus (event) {
    const focusableEls = this.getFocusableElements()
    if (!focusableEls.length) return

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (!this.contains(document.activeElement)) {
      event.preventDefault()
      firstFocusableEl.focus()
      return
    }

    if (event.shiftKey && document.activeElement === firstFocusableEl) {
      event.preventDefault()
      lastFocusableEl.focus()
    } else if (!event.shiftKey && document.activeElement === lastFocusableEl) {
      event.preventDefault()
      firstFocusableEl.focus()
    }
  }

  getFocusableElements () {
    return Array.from(
      this.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="tel"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      ),
    ).filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0)
  }

  resetForm () {
    this.els.createNewListButton.element.classList.toggle('is-active', false)
    this.els.wishlistSelect.element.classList.toggle('is-hidden', false)
    this.els.addToWishlistButton.element.classList.toggle('is-hidden', false)
    this.els.newListName.element.classList.toggle('is-hidden', true)
    this.els.newListNameLabel.element.classList.toggle('is-hidden', true)
    this.els.wishlistSelectLabel.element.classList.toggle('is-hidden', false)
  }

  handleCreateNewList () {
    const productDetails = JSON.parse(this.els.details.element.innerHTML)

    const isActive = this.els.createNewListButton.element.classList.contains(
      'is-active',
    )

    if (isActive) {
      this.els.createNewListButton.element.classList.toggle('is-hidden', true)

      const variantSelect = this.querySelector('variant-selector')
      const variantId = variantSelect.dataset.variantId
      const productId = this.dataset.product

      const product = {
        epi: variantId,
        empi: productId,
        du: window.location.href,
      }

      const newListName = this.els.newListName.element.value

      const details = {
        wishlistName: newListName,
        productImage: productDetails.featured_image,
        productTitle: productDetails.title,
      }

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }

      window.SwymCallbacks.push(() => createList(newListName, product, details))
    } else {
      this.els.createNewListButton.element.classList.toggle('is-active', true)
      this.els.wishlistSelect.element.classList.toggle('is-hidden', true)
      this.els.addToWishlistButton.element.classList.toggle('is-hidden', true)
      this.els.newListName.element.classList.toggle('is-hidden', false)
      this.els.newListNameLabel.element.classList.toggle('is-hidden', false)
      this.els.wishlistSelectLabel.element.classList.toggle('is-hidden', true)
    }
  }

  handleAddToWishlist () {
    const productDetails = JSON.parse(this.els.details.element.innerHTML)

    const variantSelect = this.querySelector('variant-selector')
    const wishlistSelect = this.querySelector('wishlist-select')

    const { variantId } = variantSelect.dataset
    const { lid, wishlistName } = wishlistSelect.dataset
    const { product: productId } = this.dataset

    const product = {
      epi: variantId,
      empi: productId,
      du: `${window.location.origin}/products/${productDetails.handle}?variant=${variantId}`,
    }

    const details = {
      wishlistName,
      productImage: productDetails.featured_image,
      productTitle: productDetails.title,
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(() => addItemToList(lid, product, details))
  }
}

if (!customElements.get('wishlist-modal')) {
  customElements.define('wishlist-modal', WishlistModal)
}
